import { FC } from "react";
import { useRecoilValue } from "recoil";

import { useCrudEditContext } from "@ryde/redux";
import { formTabControlsSF, IStationRouteDto } from "@ryde/shared";

import { FormControlsWrapper } from "../../form.controls.wrapper";
import { StationRouteTabsContentWrapperStyled } from "./station-route.styled";

export const StationRouteTabsTabProperties: FC = () => {
  const { entity } = useCrudEditContext<IStationRouteDto>();
  const currentTabControls = useRecoilValue(formTabControlsSF(entity));
  return (
    <StationRouteTabsContentWrapperStyled>
      <FormControlsWrapper controls={currentTabControls} />
    </StationRouteTabsContentWrapperStyled>
  );
};
